import { render, staticRenderFns } from "./CopyCandidates.vue?vue&type=template&id=20dfad9e&"
import script from "./CopyCandidates.vue?vue&type=script&lang=js&"
export * from "./CopyCandidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports